<template>
  <div elevation="0">
    <v-row>
      <v-col>
        <v-form @submit="loginAction" onSubmit="return false;">
          <h1 class="mb-4">
            {{ $t("login.logInVerb") }}
          </h1>
          <v-text-field
            v-model="username"
            class="rounded-lg login-input-text"
            :label="$t('login.usernameOrEmail')"
            single-line
            dense
            color="accentElement"
            :rules="[() => !!username || $t('forms.thisFieldIsRequired')]"
            outlined
            :disabled="getInProgress"
          >
            <template v-slot:append-outer>
              <div class="error-append">
                <img v-if="errors" src="@/assets/warning.svg" />
              </div>
            </template>
          </v-text-field>
          <v-text-field
            v-model="password"
            class="rounded-lg login-input-text"
            :label="$t('login.password')"
            single-line
            dense
            :counter="MAX_PASSWORD_LENGTH"
            :type="showPassword ? 'text' : 'password'"
            :maxlength="MAX_PASSWORD_LENGTH"
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="showPassword = !showPassword"
            :rules="[rules.required]"
            :error-messages="errors"
            outlined
            :disabled="getInProgress"
          >
            <template v-slot:append-outer>
              <div class="error-append">
                <img v-if="errors" src="@/assets/warning.svg" />
              </div>
            </template>
          </v-text-field>
          <v-row align="center" style="display: none">
            <v-col>
              <v-checkbox :label="$t('login.rememberMe')" />
            </v-col>
            <v-col>
              <i18n path="login.forgotPassword" tag="label" for="tos">
                <a :href="'https://google.ca'" target="_blank">{{
                  $t("login.forgotPassword0")
                }}</a>
              </i18n>
            </v-col>
          </v-row>
          <v-btn
            :disabled="getInProgress"
            :loading="getInProgress"
            color="primary"
            block
            type="submit"
            >{{ $t("login.logInVerb") }}</v-btn
          >
        </v-form>
      </v-col>
    </v-row>
    <v-row align="center" class="mt-10" no-gutters>
      <v-col><div class="or-hr-side" /></v-col>
      <v-col class="or-hr-text text-uppercase px-2" cols="auto"
        ><span>{{ $t("login.or") }}</span></v-col
      >
      <v-col><div class="or-hr-side" /></v-col>
    </v-row>
    <v-row>
      <v-sheet>
        <i18n path="login.youAgree">
          <a href="https://www.storycity.com.au/terms-of-use/" target="_blank">{{
            $t("login.youAgree0")
          }}</a>
          <a href="https://www.storycity.com.au/privacy-policy/" target="_blank">{{
            $t("login.youAgree1")
          }}</a>
        </i18n>
      </v-sheet>
    </v-row>
    <v-row class="my-9">
      <v-btn to="/auth/register" block color="primary">{{
        $t("register.signUpWithEmail")
      }}</v-btn>
    </v-row>
    <v-row>
      <v-col cols=6>
        <a
          href="https://play.google.com/store/apps/details?id=au.com.storycity.storycity&hl=en_CA&gl=US"
          ><img
            style="height: 50px"
            alt="Get it on Google Play"
            src="@/assets/googlePlay.svg"
        /></a>
      </v-col>
      <v-col cols=6> 
        <a href="https://apps.apple.com/us/app/story-city/id972223741">
          <img 
            style="height: 50px"
          src="@/assets/appleStore.svg" alt="Download on the Apple App Store" />
        </a>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import { MAX_PASSWORD_LENGTH } from "@/const";
export default {
  computed: {
    ...mapGetters("auth/login", [
      "getInProgress",
      "getSuccess",
      "getErrorMessages",
    ]),
    ...mapGetters("auth", ["getMe"]),
    userId() {
      return this.$root.userId;
    },
    errors() {
      let errorText = "";
      if (this.getErrorMessages.length == 0) {
        return null;
      } else {
        for (const error of this.getErrorMessages) {
          errorText += error;
        }
      }
      return errorText;
    },
  },
  created() {
    this.MAX_PASSWORD_LENGTH = MAX_PASSWORD_LENGTH;
  },
  methods: {
    ...mapMutations("auth", ["setMe"]),
    loginAction() {
      this.logIn({ username: this.username, password: this.password, redirect: this.$route.query.redirect });
    },
    ...mapActions("auth/login", ["logIn"]),
    logout() {
      localStorage.removeItem("token");
      localStorage.removeItem("refresh_token");
      this.setMe(null);
    },
  },
  watch: {
    getSuccess(newValue) {
      if (newValue == true) {
        this.username = "";
        this.password = "";
      }
    },
  },
  data() {
    return {
      username: "",
      password: "",
      showPassword: false,
      rules: {
        required: (value) => !!value || this.$t("forms.thisFieldIsRequired"),
      },
    };
  },
};
</script>
<style lang="scss" scoped>
::v-deep .login-input-text fieldset {
  border: 2px solid;
  border-radius: 16px;
}
.or-hr-side {
  border: 2px solid var(--v-accentElement-base);
  border-radius: 2px;
}
.or-hr-text {
  font-size: 1.5em;
}
::v-deep h1 {
  font-size: 1.3em;
  text-align: left;
}
.error-append {
  width: 2em;
  position: absolute;
  padding-left: 8px;
}
::v-deep .v-input__append-outer {
  margin-left: 0px !important;
  margin-right: 0 !important;
}
</style>
